/** @format */

import { BASE_URL, XAMPLIFIER_BASE_URL } from "../config";

export const API_ROUTES = {
  GET_CONFIG: `${BASE_URL}getConfig`,

  GET_LOCATION: `${BASE_URL}getLocation`,
  GET_PROVIDERS: `${BASE_URL}getProviders`,
  GET_SERVICE_TYPE: `${BASE_URL}getServiceType`,
  GET_PATIENT: `${BASE_URL}getPatients`,
  GET_PATIENT_DETAILS: `${BASE_URL}getPatientsAndLastAppointments`,

  GET_STATES: `${BASE_URL}getStates`,
  GET_INSURANCE: `${BASE_URL}getInsurance`,
  // GET_CLIENTBRAND: `${BASE_URL}getClientBrands`,
  GET_TOPINSURANCE: `${BASE_URL}insurance/topInsurancePackage`,
  GET_ASSIGN_CONFIG: `${BASE_URL}getAssignConfig`,
  GET_PATIENT_APPOINTMENTS: `${BASE_URL}getPatientAppointments`,

  POST_CREATE_PATIENT: `${BASE_URL}createPatients`,
  POST_CREATE_PATIENT_INSURANCE: `${BASE_URL}insurance/postInsurance`,
  POST_JOINWAITLIST: `${BASE_URL}createWaitList`,
  POST_ANALYTICS: `${BASE_URL}updateUserSession`,

  GET_INSURANCE_PROVIDER_MAP: `${BASE_URL}getInsuranceProviderMap`,
  GET_PROVIDER_INSURANCE: `${BASE_URL}getProviderInsurance`,
  PUT_BOOKING_APPOINTMENT: `${BASE_URL}bookAppointment`,
  GET_RELATIONSHIP: `${BASE_URL}insurance/getRelationshipToPatient`,

  //Admin
  GET_ADMIN_LOCATION: `${BASE_URL}providerLocationMap`,
  GET_ADMIN_SERVICETYPE: `${BASE_URL}getProviderAppointmentMap`,
  GET_ALL_PROVIDER: `${BASE_URL}getAllProviders`,
  GET_SINGLE_PROVIDER: `${BASE_URL}getProviderByProviderId`,
  GET_WAITLIST: `${BASE_URL}getWaitList`,
  GET_SERVICELOCATION_MAPPING: `${BASE_URL}getServiceLocationMapping`,
  GET_USER_DETAILS: `${XAMPLIFIER_BASE_URL}user`,
  GET_CLIENTBRAND: `${XAMPLIFIER_BASE_URL}clients`,
  GET_SWITCH_CLIENT: `${XAMPLIFIER_BASE_URL}switch/clients`,
  GET_INSURANCE_TYPE: `${BASE_URL}getInsuranceType`,
  GET_INSURANCE_CONTROL_DATA: `${BASE_URL}insurance/getInsuranceControlData`,
  GET_PROVIDER_INSURANCE_PLAN: `${BASE_URL}insurance/getProviderByInsurancePlan`,
  GET_REPORTS: `${BASE_URL}getAppointmentReport`,
  GET_ANALYTICS_REPORT: `${BASE_URL}report/getChartReport`,
  GET_CHANNEL: `${BASE_URL}report/getChannelFilters`,
  GET_APPOINTMENT_REPORTS: `${BASE_URL}report/getAppointmentReport`,

  POST_UPDATA_LOCATION_MAPPING: `${BASE_URL}providerLocationMapAssign`,
  POST_UPDATA_SERVICE_MAPPING: `${BASE_URL}insertApptProviderMap`,
  POST_SERVICELOCATION_CONFIG: `${BASE_URL}createServiceLocationConfig`,
  POST_CREATE_LOCATION_PROVIDER_CONFIG: `${BASE_URL}createLocationProviderConfig`,
  POST_CREATE_PROVIDER_INSURANCE: `${BASE_URL}createInsuranceProviderConfig`,
  POST_INSURANCE_VALIDATION: `${BASE_URL}insuranceValidation`,
  POST_LOGIN: `${XAMPLIFIER_BASE_URL}login`,
  POST_ADMIN_LOGIN: `${BASE_URL}adminLogin`,

  PATCH_UPDATA_PROVIDERINFO: `${BASE_URL}updateProviderInfo`,
  PATCH_UPDATE_CONFIG: `${BASE_URL}updateConfig`,
};
